<template>
  <div>
    <PageMain
      :loading="loading"
      :tableData="tableData"
      @reload="$refs.header.query()"
      ref="tableMain"
      @radio-change="(e) => $emit('radio-change', e)"
    >
      <page-header ref="header" slot="header" @query="getData" />
    </PageMain>
  </div>
</template>
<script>
import PageMain from './table.vue'
import PageHeader from './header'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: { PageMain, PageHeader },
  props: {
    payeeScmCode: { type: String, default: () => '' },
    payeeCustCode: { type: String, default: () => '' },
  },
  data() {
    return { loading: false, tableData: [] }
  },
  methods: {
    async getData(form = {}) {
      let listApi
      let listData = {}
      if (this.payeeScmCode) {
        listApi = this.$api.masterScmInfoBankListApi
        listData = { scmCode: this.payeeScmCode, ...form }
      } else if (this.payeeCustCode) {
        listApi = this.$api.masterCustomerBankListApi
        listData = { custCode: this.payeeCustCode, ...form }
      } else {
        this.tableData = []
        return
      }
      this.loading = true
      listApi({
        ...listData,
      })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
